import userService from "../../../services/user.service";

async function getSubTasks({
  pageNumber = -1,
  pageSize = 0,
  searchQuery = "",
}) {
  try {
    const response = await userService.getSubTasks(
      pageNumber,
      pageSize,
      searchQuery
    );
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to fetch subtasks."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching subtasks:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function addSubTaskToDatabase({ name, description, isActive }) {
  try {
    const payload = {
      name,
      description,
      active: isActive,
    };
    const response = await userService.addSubTask(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return JSON.stringify(response.data.message) || "Failed to add subtask.";
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding subtask:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function updateSubTaskInDatabase({
  subTaskId,
  name,
  description,
  isActive,
}) {
  try {
    const payload = {
      id: subTaskId,
      name,
      description,
      active: isActive,
    };
    const response = await userService.updateSubTask(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to update subtask."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating subtask:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  addSubTaskToDatabase,
  getSubTasks,
  updateSubTaskInDatabase,
  subTaskTools: [
    {
      type: "function",
      function: {
        name: "getSubTasks",
        description:
          "Fetch all subtasks from the database. You must return all subtasks without skipping any data.",
        parameters: {
          type: "object",
          properties: {
            pageNumber: {
              type: "integer",
              description:
                "Page number for pagination by default it is -1 for fetching all subTasks",
            },
            pageSize: {
              type: "integer",
              description:
                "Number of subtasks per page  by default it is 0 for fetching all subTasks",
            },
            searchQuery: {
              type: "string",
              description:
                "Search query for filtering  by default it is empty string for fetching all subTasks",
            },
          },
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updateSubTaskInDatabase",
        description: "Update an existing subtask in the database",
        parameters: {
          type: "object",
          properties: {
            subTaskId: {
              type: "string",
              description: "The unique ID of the subtask to be updated",
            },
            name: {
              type: "string",
              description: "Name of the subtask",
            },
            description: {
              type: "string",
              description: "Detailed description of the subtask",
            },
            isActive: {
              type: "boolean",
              description: "Whether the subtask is active or not",
            },
          },
          required: ["subTaskId", "name", "description"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addSubTaskToDatabase",
        description: "Add a new subtask to the database",
        parameters: {
          type: "object",
          properties: {
            name: {
              type: "string",
              description: "Name of the subtask",
            },
            description: {
              type: "string",
              description: "Detailed description of the subtask",
            },
            isActive: {
              type: "boolean",
              description: "Whether the subtask is active or not",
            },
          },
          required: ["name", "description", "taskId"],
        },
      },
    },
  ],
};
